namespace Solovis.InvDataSelectors {

  export class PropertySelectorControl extends Solovis.UI.BaseControl {

    private _portalServices: Solovis.Portal.IPortalServices;

    public _selectionCallback;
    public _cancelCallback;
    public _selectedProperty;
    public settings;
    public _filter;
    public _jsonModelEnv;
    public _propertyList;
    public _filterListControl: Solovis.UI.StringFilterListControl;
    public _availableHeight;
    public _showIncludeHiddenItemsRow;
    public _filterInputValue;

    constructor(options) {
      super(options);

      if (options.portalServices) {
        this._portalServices = options.portalServices;
      }
      else {
        this._portalServices = new Solovis.Portal.SitePortalServices();
      }

      // selectionCallback should be a function that takes an item.
      this._selectionCallback = options.selectionCallback ? options.selectionCallback : null;
      this._cancelCallback = options.cancelCallback ? options.cancelCallback : null;

      this._selectedProperty = options.initialValue ? options.initialValue : null;

      this.settings = options.settings ? options.settings : {};
      this._filter = this.settings.filter ? this.settings.filter : {};
      this._showIncludeHiddenItemsRow = !!this.settings.showIncludeHiddenItemsRow;
    }

    public async doInitAsync(): Promise<void> {
      let response = await this._portalServices.rpc().invoke(
        "~/Selectors/PropertySelector/GetPropertyDefinitions",
        { filter: this._filter });

      this._jsonModelEnv = response.result.modelEnvironment;

      var propList = this._jsonModelEnv.propertyDefinitions;

      this._propertyList = propList.sort((a, b) => {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      });
    }

    public setAvailableHeight(overallHeight) {
      var self = this;

      if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
        this._filterListControl.setAvailableHeight(overallHeight);
      }
      else {
        // The control is still rendering, so we will store the overallHeight and defer until the render is complete
        this._availableHeight = overallHeight;
      }
    }

    public doRender() {
      var self = this;

      var selectorControlHostDiv = $("<div>")
        .addClass("solovis-input")
        .appendTo(this.container);

      const includeHiddenListItem = {
        id: -1,
        code: "includeHidden",
        label: "Include Hidden Properties"
      };

      const includeHiddenListItemDivGenerator = (itemHolder, filterOptions) => {
        const itemDiv = $("<div>").text(itemHolder.label);

        itemDiv.css({
          color: "#007bff",
          backgroundColor: "#f1f3f5",
          padding: "8px 12px",
          fontSize: "14px",
          fontWeight: "500",
          fontStyle: "italic",
          borderRadius: "4px",
          cursor: "pointer",
          textAlign: "center"
        });

        return itemDiv;
      };

      const hiddenOptionExists = this._propertyList.some(option => option.code === includeHiddenListItem.code);
      const shouldIncludeAdditionalItem = this._showIncludeHiddenItemsRow && !hiddenOptionExists && this._filter !== null;

      this._filterListControl = new Solovis.UI.StringFilterListControl({
        controlHost: selectorControlHostDiv,
        listItems: this._propertyList,
        selectedItem: this._selectedProperty,
        additionalListItem: shouldIncludeAdditionalItem ? includeHiddenListItem : null,
        additionalListItemDivGenerator: shouldIncludeAdditionalItem ? includeHiddenListItemDivGenerator : null,
        filterInputValue: this._filterInputValue
      });

      $(this._filterListControl)
        .on("selectionChanged", async function () {
          var selectedItem = self._filterListControl.getSelectedItem();

          // Check if the selected item is the "Include Hidden Properties" link
          if (selectedItem && selectedItem.code === includeHiddenListItem.code) {

            self._availableHeight = self._filterListControl.getAvailableHeight();
            self._filterInputValue = self._filterListControl._filterInput.getValue();
            self._showIncludeHiddenItemsRow = false;
            // Perform the action: Set filter to null and reload data
            self._filter = null;
            await self.doInitAsync(); // Reload with updated filter
            $(self.container).empty();
            self.doRender();
          } else if (self._selectionCallback) {
            // Proceed with the regular selection callback
            self._selectionCallback(selectedItem);
          }
        })
        .on("renderComplete", function () {
          if (self._availableHeight) {
            self._filterListControl.setAvailableHeight(self._availableHeight);
            self._availableHeight = null;
          }
          self._filterListControl.focusFilter();
        })
        .on("escapeKey", function () {
          if (self._cancelCallback) {
            self._cancelCallback();
          }
        });

      this._filterListControl.setAsCurrentControl();

      this._filterListControl.scrollToSelectedItem();
    }

    public focus() {
      // If the control is still rendering, it will focus once rendering is complete
      if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
        this._filterListControl.focusFilter();
      }
    }
  }
}